"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractUrlExtension = void 0;
function extractUrlExtension(url) {
    var _a;
    return (_a = url.pathname.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
}
exports.extractUrlExtension = extractUrlExtension;
//# sourceMappingURL=extractUrlExtension.js.map